// All of the requested modules are loaded behind enumerable getters.
const map = Object.defineProperties({}, {
  "./(public)/_layout.tsx": { enumerable: true, get() { return import("/Users/adrianfrey/Dev/projects/zoukessence/src/app/(public)/_layout.tsx"); } },
  "./(public)/about.tsx": { enumerable: true, get() { return import("/Users/adrianfrey/Dev/projects/zoukessence/src/app/(public)/about.tsx"); } },
  "./(public)/events.tsx": { enumerable: true, get() { return import("/Users/adrianfrey/Dev/projects/zoukessence/src/app/(public)/events.tsx"); } },
  "./(public)/index.tsx": { enumerable: true, get() { return import("/Users/adrianfrey/Dev/projects/zoukessence/src/app/(public)/index.tsx"); } },
  "./(public)/info.tsx": { enumerable: true, get() { return import("/Users/adrianfrey/Dev/projects/zoukessence/src/app/(public)/info.tsx"); } },
  "./(public)/kontakt.tsx": { enumerable: true, get() { return import("/Users/adrianfrey/Dev/projects/zoukessence/src/app/(public)/kontakt.tsx"); } },
  "./(public)/kurse.tsx": { enumerable: true, get() { return import("/Users/adrianfrey/Dev/projects/zoukessence/src/app/(public)/kurse.tsx"); } },
  "./_layout.tsx": { enumerable: true, get() { return import("/Users/adrianfrey/Dev/projects/zoukessence/src/app/_layout.tsx"); } },
  "./admin/_layout.tsx": { enumerable: true, get() { return import("/Users/adrianfrey/Dev/projects/zoukessence/src/app/admin/_layout.tsx"); } },
  "./admin/finanzen.tsx": { enumerable: true, get() { return import("/Users/adrianfrey/Dev/projects/zoukessence/src/app/admin/finanzen.tsx"); } },
  "./admin/index.tsx": { enumerable: true, get() { return import("/Users/adrianfrey/Dev/projects/zoukessence/src/app/admin/index.tsx"); } },
  "./admin/klienten.tsx": { enumerable: true, get() { return import("/Users/adrianfrey/Dev/projects/zoukessence/src/app/admin/klienten.tsx"); } },
  "./admin/kommunikation.tsx": { enumerable: true, get() { return import("/Users/adrianfrey/Dev/projects/zoukessence/src/app/admin/kommunikation.tsx"); } },
  "./admin/kurse.tsx": { enumerable: true, get() { return import("/Users/adrianfrey/Dev/projects/zoukessence/src/app/admin/kurse.tsx"); } },
  "./admin/lehrer.tsx": { enumerable: true, get() { return import("/Users/adrianfrey/Dev/projects/zoukessence/src/app/admin/lehrer.tsx"); } },
  "./admin/login.tsx": { enumerable: true, get() { return import("/Users/adrianfrey/Dev/projects/zoukessence/src/app/admin/login.tsx"); } },
});

function metroContext(request) {
    return map[request];
}

// Return the keys that can be resolved.
metroContext.keys = function metroContextKeys() {
  return Object.keys(map);
};

// Return the module identifier for a user request.
metroContext.resolve = function metroContextResolve(request) {
  throw new Error('Unimplemented Metro module context functionality');
}

module.exports = metroContext;